/** Workbench-wide Mock / Cached / Live data source mode (session-scoped). */

export type WorkbenchDataMode = 'mock' | 'cached' | 'live';

export const WORKBENCH_DATA_MODE_KEY = 'workbench_data_mode';

export function readWorkbenchDataMode(): WorkbenchDataMode {
    try {
        const v = sessionStorage.getItem(WORKBENCH_DATA_MODE_KEY);
        if (v === 'mock' || v === 'cached' || v === 'live') return v;
    } catch {
        /* private mode / SSR */
    }
    return 'live';
}

export function writeWorkbenchDataMode(mode: WorkbenchDataMode): void {
    try {
        sessionStorage.setItem(WORKBENCH_DATA_MODE_KEY, mode);
    } catch {
        /* ignore */
    }
}

export const MOCK_MODE_TOAST =
    'Mock mode — chain APIs are disabled. Switch to Live or Cached to fetch blockchain data.';

export const CACHED_MISS_TOAST =
    'Cached mode — no stored transactions for this address. Switch to Live to fetch from chain providers.';
